module.exports = __webpack_public_path__ + "media/images/pc/stores/nagoya/access/sakae_point4-8519c6ac075b79a06cf761be23852cc7.jpg";